import { Box, Image, Text, Center } from '@chakra-ui/react';
import type { User } from '@halo/chat-sdk-react';
import EmptyFeeds from './images/empty-feeds.png';

interface FeedsContentProps {
  user?: User | null;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const FeedsContent = ({ user }: FeedsContentProps) => {
  const { t } = useTranslation();
  // console.log(user);
  return (
    <Box>
      <Center flexDir="column" gap="2">
        <Image w="165px" h="100px" src={EmptyFeeds} alt="empty feeds" />
        <Text fontSize="sm">{t('profile.feedsTips')}</Text>
      </Center>
    </Box>
  );
};

const MemoizedFeedsContent = memo(FeedsContent);
export { MemoizedFeedsContent as FeedsContent };
